//CORE
import React from "react";

//REDUX
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as reduxActions from "store/actions";
import reduxStore from "store/";

//COMPONENTS
import AgileOverview from "components/AgileV2/overview";
import CustomButton from "components/Buttons/custom";
import Filter from "componentsV3/Filter/menuFilter";
import MoreMenu from "components/MoreMenu";

//FUNCTIONS
import {
    customApp,
    translate,
} from "functions/";

import {
    countNotifications
} from "functions/cards"

import {
    loadCardsV2,
} from "functions/loadData"


function StrategyAndPlansOverviewView(props) {
    const { db } = reduxStore.getState()
    const [viewCompleted, setViewCompleted] = React.useState(false)
    const [viewCatenation, setViewCatenation] = React.useState(true)
    const [viewColors, setViewColors] = React.useState(true)
    const [onlyUnReaded, setOnlyUnReaded] = React.useState(false)
    const [showDeleted, setShowDeleted] = React.useState(false)
    const [loadingDeleted, setLoadingDeleted] = React.useState(false)
    const [showCheck, setShowCheck] = React.useState(false)
    const [triggerExport, setTriggerExport] = React.useState(false)

    let hashs = window.location.hash.split('/')
    hashs[0] = hashs[0].replace('#', '')

    React.useEffect(() => {
        return () => {
            props.reduxFunction("ASYNC", "SET_CONTROL", {
                ...reduxStore.getState().controls,
                deleted: false
            })
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    React.useEffect(() => {
        if (showDeleted)
            loadDeletedCards()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [showDeleted])

    const loadDeletedCards = async () => {
        setLoadingDeleted(true)
        let Nhashs = window.location.hash.split("/")
        Nhashs[0] = Nhashs[0].replace("#", "")

        let lc = await loadCardsV2(props, {
            idRel: Nhashs[0],
            cardLoad: 'deleted',
        })
        if (lc)
            setLoadingDeleted(false)
    }

    let unReadeds = 0
    Object.keys(db.cards).filter(a => {
        let notifications = countNotifications(a)
        if (db.cards[a]
            && !db.cards[a].deleted
            && (
                db.cards[a]._planId === hashs[0]
                || db.cards[a]._parent === hashs[0]
            )
            && (
                viewCompleted
                ||
                (
                    !viewCompleted
                    && db.cards[a].status !== "completed"
                )
            )
            && notifications.total > 0
        )
            return true
        return false
    }).forEach(a => {
        let notifications = countNotifications(a)
        unReadeds = unReadeds + notifications.total
    })

    return (
        <div style={{ padding: 3 }}>
            {/* Barra de ferramentas compacta */}
            <div style={{
                padding: "22px 16px",
                backgroundColor: "#ffffff",
                borderBottom: "1px solid rgba(0, 0, 0, 0.08)",
                boxShadow: "0 1px 2px rgba(0, 0, 0, 0.04)"
            }}>
                <div style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    gap: "8px",
                    flexWrap: "wrap"
                }}>
                    {/* Filtros - lado esquerdo */}
                    <div style={{ flex: 1, minWidth: "250px", maxWidth: "400px" }}>
                        <Filter
                            fields={['text', 'date', 'tags', 'priority', 'unit', 'usersMode', 'users', 'responsible']}
                            showFilters
                        />
                    </div>

                    {/* Ações - lado direito */}
                    <div style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "6px"
                    }}>
                        {/* Botões principais */}
                        {unReadeds > 0 && (
                            <CustomButton
                                title={onlyUnReaded ? translate(`$__hideUnreaded`, '*') : translate(`$__showUnreaded`, '*')}
                                color={onlyUnReaded ? customApp('menu') : '#757575'}
                                icon={"mail_outline"}
                                transparent
                                onClick={() => setOnlyUnReaded(prev => !prev)}
                                badgeContent={unReadeds}
                                size={'20px'}
                                style={{
                                    padding: "6px 8px",
                                    backgroundColor: onlyUnReaded ? 'rgba(63, 81, 181, 0.08)' : 'transparent',
                                    border: '1px solid rgba(0, 0, 0, 0.12)',
                                    borderRadius: '6px',
                                    minWidth: '40px'
                                }}
                            />
                        )}

                        <CustomButton
                            title={showCheck ? translate(`$__hideSelection`, '*') : translate(`$__selectCards`, '*')}
                            color={showCheck ? customApp('menu') : "#757575"}
                            icon={"check_circle_outline"}
                            transparent
                            onClick={() => setShowCheck(prev => !prev)}
                            size={'20px'}
                            style={{
                                padding: "6px 8px",
                                backgroundColor: showCheck ? 'rgba(63, 81, 181, 0.08)' : 'transparent',
                                border: '1px solid rgba(0, 0, 0, 0.12)',
                                borderRadius: '6px',
                                minWidth: '40px'
                            }}
                        />

                        <CustomButton
                            title={viewCompleted ? translate(`$__hideCompleted`, '*') : translate(`$__showCompleted`, '*')}
                            color={viewCompleted ? customApp('menu') : "#757575"}
                            icon={viewCompleted ? "visibility_off" : "visibility"}
                            transparent
                            onClick={() => setViewCompleted(prev => !prev)}
                            size={'20px'}
                            style={{
                                padding: "6px 8px",
                                backgroundColor: viewCompleted ? 'rgba(63, 81, 181, 0.08)' : 'transparent',
                                border: '1px solid rgba(0, 0, 0, 0.12)',
                                borderRadius: '6px',
                                minWidth: '40px'
                            }}
                        />

                        {/* Separador */}
                        <div style={{
                            width: "1px",
                            height: "28px",
                            backgroundColor: "rgba(0, 0, 0, 0.12)",
                            margin: "0 2px"
                        }}></div>

                        {/* Menu de Visualização */}
                        <MoreMenu
                            icon={"tune"}
                            horizontalButton
                            size={'20px'}
                            transparent
                            title={translate("$__viewOptions")}
                            style={{
                                border: '1px solid rgba(0, 0, 0, 0.12)',
                                borderRadius: '6px',
                                padding: "6px 8px",
                                backgroundColor: 'transparent',
                                minWidth: '40px'
                            }}
                            color={customApp('menu')}
                            btColor={"#757575"}
                            options={[
                                {
                                    name: translate("$__exportToExcel"),
                                    icon: "file_download",
                                    color: customApp('menu'),
                                    onClick: () => {
                                        setTriggerExport(prev => !prev)
                                    },
                                },
                                {
                                    name: db.orderByTitlePosition === 'ASC' ? translate("$__orderByAsc") : translate("$__orderByDesc"),
                                    icon: db.orderByTitlePosition === 'ASC' ? "text_rotation_down" : "text_rotate_up",
                                    onClick: () => {
                                        props.reduxFunction("ASYNC", "SET_DB", {
                                            ...reduxStore.getState().db,
                                            orderByTitlePosition: reduxStore.getState().db.orderByTitlePosition === 'ASC' ? 'DESC' : 'ASC'
                                        })
                                    },
                                },
                                {
                                    name: db.orderByTitle ? translate("$__manualOrder") : translate("$__orderByName"),
                                    icon: db.orderByTitle ? "drag_handle" : "format_list_numbered_rtl",
                                    onClick: () => {
                                        props.reduxFunction("ASYNC", "SET_DB", {
                                            ...reduxStore.getState().db,
                                            orderByTitle: !reduxStore.getState().db.orderByTitle
                                        })
                                    },
                                },
                                {
                                    name: viewColors ? translate("$__hideCatenationColors") : translate("$__showCatenationColors"),
                                    icon: "palette",
                                    color: viewColors ? customApp('menu') : '#999',
                                    onClick: () => {
                                        setViewColors(prev => !prev)
                                    },
                                },
                                {
                                    name: translate("$__groupByColor"),
                                    icon: "gradient",
                                    color: db.groupByColor ? customApp('menu') : '#999',
                                    onClick: () => {
                                        props.reduxFunction("ASYNC", "SET_DB", {
                                            ...reduxStore.getState().db,
                                            groupByColor: !db.groupByColor
                                        })
                                    },
                                },
                                {
                                    name: translate("$__showCatenation"),
                                    icon: viewCatenation ? "link" : "link_off",
                                    color: viewCatenation ? customApp('menu') : '#999',
                                    onClick: () => {
                                        setViewCatenation(prev => !prev)
                                    },
                                },
                            ]}
                        />

                        {/* Deletados */}
                        <CustomButton
                            title={!reduxStore.getState().controls.deleted ? translate("$__showDeleted") : translate("$__hideDeleted")}
                            color={reduxStore.getState().controls.deleted ? '#f44336' : "#757575"}
                            load={loadingDeleted}
                            icon={"delete_outline"}
                            transparent
                            onClick={() => {
                                setShowDeleted(prev => !prev)
                                props.reduxFunction("ASYNC", "SET_CONTROL", {
                                    ...reduxStore.getState().controls,
                                    deleted: !showDeleted
                                })
                            }}
                            size={'20px'}
                            style={{
                                padding: "6px 8px",
                                backgroundColor: reduxStore.getState().controls.deleted ? 'rgba(244, 67, 54, 0.08)' : 'transparent',
                                border: reduxStore.getState().controls.deleted ? '1px solid #f44336' : '1px solid rgba(0, 0, 0, 0.12)',
                                borderRadius: '6px',
                                minWidth: '40px'
                            }}
                        />
                    </div>
                </div>
            </div>

            {/* Componente AgileOverview */}
            <AgileOverview
                nodeId={hashs[0] || null}
                showCompleted={viewCompleted}
                showCatenation={viewCatenation}
                showCheck={showCheck}
                handleCheckBoxState={() => setShowCheck(prev => !prev)}
                showColors={viewColors}
                onlyUnReaded={onlyUnReaded}
                triggerExport={triggerExport}
                styles={{
                    discountHeight: 90
                }}
            />
        </div>
    )
}

const mapStateToProps = (store) => ({
    groupByColor: store.db.groupByColor,
    orderByTitle: store.db.orderByTitle,
    orderByTitlePosition: store.db.orderByTitlePosition,
});
const mapDispatchToProps = dispatch =>
    bindActionCreators(reduxActions, dispatch)

export default connect(mapStateToProps, mapDispatchToProps)(StrategyAndPlansOverviewView)
